var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetBackgroundColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "#50429B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0052 3.83594V0.335938L5.33854 5.0026L10.0052 9.66927V6.16927C13.8669 6.16927 17.0052 9.3076 17.0052 13.1693C17.0052 16.6343 14.4735 19.5043 11.1719 20.0643V22.4209C15.7802 21.8493 19.3385 17.9293 19.3385 13.1693C19.3385 8.0126 15.1619 3.83594 10.0052 3.83594ZM3.00521 13.1693C3.00521 11.2443 3.78688 9.49427 5.05854 8.2226L3.40188 6.56594C1.6535 8.31879 0.67172 10.6935 0.671875 13.1693C0.671875 17.9293 4.23021 21.8493 8.83854 22.4209V20.0643C5.53688 19.5043 3.00521 16.6343 3.00521 13.1693Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetBackgroundColor);
export default __webpack_public_path__ + "static/media/reset-background-color.fe04c290c37b34ae93baca0b5287b7c5.svg";
export { ForwardRef as ReactComponent };